<template>
  <div class="bjzc-contact-form border-radius">
    <h4>{{ $t('messages.contact_form.title') }}</h4>
    <form class="uk-flex uk-flex-wrap">
      <div class="uk-width-1-3@l">
        <label class="uk-form-label left-label uk-visible@m">{{ $t('messages.contact_form.name') }}</label>
        <div class="uk-form-controls">
          <label class="uk-form-label top-label uk-hidden@m">{{ $t('messages.contact_form.name') }}</label>
          <input v-model="form.name" class="uk-input" type="text" :placeholder="$t('messages.contact_form.name_ph')" />
        </div>
      </div>
      <div class="uk-width-1-3@l">
        <label class="uk-form-label left-label uk-visible@m">{{ $t('messages.contact_form.mobile') }}</label>
        <div class="uk-form-controls">
          <label class="uk-form-label top-label uk-hidden@m">{{ $t('messages.contact_form.mobile') }}</label>
          <input
            v-model="form.mobile"
            class="uk-input"
            type="tel"
            :placeholder="$t('messages.contact_form.mobile_ph')"
          />
        </div>
      </div>
      <div class="uk-width-1-3@l">
        <label class="uk-form-label left-label uk-visible@m">{{ $t('messages.contact_form.address') }}</label>
        <div class="uk-form-controls">
          <label class="uk-form-label top-label uk-hidden@m">{{ $t('messages.contact_form.address') }}</label>
          <input
            v-model="form.address"
            class="uk-input"
            type="text"
            :placeholder="$t('messages.contact_form.address_ph')"
          />
        </div>
      </div>
      <div class="uk-width-1-1">
        <label class="uk-form-label left-label textarea-label uk-visible@m">{{
          $t('messages.contact_form.content')
        }}</label>
        <div class="uk-form-controls">
          <label class="uk-form-label top-label uk-hidden@m">{{ $t('messages.contact_form.content') }}</label>
          <textarea
            v-model="form.content"
            class="uk-textarea"
            rows="3"
            :placeholder="$t('messages.contact_form.content_ph')"
          />
        </div>
      </div>
    </form>
    <div class="uk-visible@m">
      <label class="left-label uk-invisible">提交按钮</label>
      <button class="bjzc-button bjzc-button-square" @click="submit">{{ $t('messages.contact_form.submit') }}</button>
    </div>
    <div class="uk-hidden@m uk-text-center">
      <button class="bjzc-button bjzc-button-square" @click="submit">{{ $t('messages.contact_form.submit') }}</button>
    </div>
  </div>
</template>

<script>
const re1 = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
const re2 = /^(0[1-9]\d{1,2})\d{6,7}$/
export default {
  name: '',
  components: {},
  data() {
    return {
      form: {
        name: '',
        mobile: '',
        address: '',
        content: ''
      }
    }
  },
  created() {},
  methods: {
    notify(message = '') {
      window.UIkit.notification({ message, status: 'warning', pos: 'top-right' })
    },
    submit() {
      const lang = this.$i18n.locale
      // validate
      const someFieldEmpty = Object.keys(this.form).some(key => {
        const value = this.form[key] || ''
        return !value.trim()
      })
      if (someFieldEmpty)
        return alert(
          lang === 'zh' ? '请您完成表单内容填写后，再进行提交！' : 'Please complete the form content before submitting!'
        )
      const isNumberValid = re1.test(this.form.mobile) || re2.test(this.form.mobile)
      if (!isNumberValid) {
        return alert(
          lang === 'zh'
            ? '请填写正确的电话号码，方便我们与您取得联系。'
            : 'Please fill in the correct phone number so that we can get in touch with you.'
        )
      }
      this.$axios.post('contacts', { ...this.form }).then(res => {
        this.form = {
          name: '',
          mobile: '',
          address: '',
          content: ''
        }
        if (res.status === 200) {
          alert(lang === 'zh' ? '提交成功！' : 'Submitted successfully!')
        } else {
          alert(lang === 'zh' ? '请勿重复提交！' : 'Do not submit repeatedly!')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.bjzc-contact-form {
  padding: 1.25rem;
  background-image: url('~@/assets/images/bg/contact-form.png');
  background-size: cover;
  margin-top: 2.5rem;

  label {
    display: inline-block;
    font-size: 0.875rem;
    color: $text-main;
  }

  .uk-input,
  .uk-textarea {
    border-radius: 0.25rem;
    border-color: #e5e7ea;
    &:focus {
      border-color: $color-primary;
    }
  }

  form > div {
    display: flex;
    align-items: center;
    margin-bottom: 0.63rem;
  }
  .left-label {
    width: 3.6rem;
    text-align: right;
    margin-right: 0.63rem;
    &.textarea-label {
      align-self: flex-start;
      margin-top: 0.38rem;
    }
  }
  .top-label {
    margin-bottom: 0.5rem;
  }
  .uk-form-controls {
    flex: 1;
    // min-width: 16.75rem;
  }
}
@media (max-width: ($screen-width-m - 1)) {
  .bjzc-contact-form {
    padding: 1.25rem 0.63rem 1.88rem;

    margin-top: 3.75rem;
  }
}
</style>
